import { BasketOffOutlineIcon } from './BasketOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 2D28FB7D-8AEA-4ED6-BB7D-DA76EC3DA4EB
 * name basket-off-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-off-outline.svg
 * tags
 * - Shopping 
 */
export const ShoppingBasketOffOutlineIcon = BasketOffOutlineIcon;
export default ShoppingBasketOffOutlineIcon